import { cn } from '@/lib/utils';
import { gradeTone, type PillTone } from './tone';

/**
 * Round letter-grade badge (design prototype `.grade`) — a filled circle with
 * the grade letter, colored by severity. Used by the Business Area cards.
 */
const TONES: Partial<Record<PillTone, string>> = {
  ok: 'bg-success',
  warn: 'bg-warning',
  crit: 'bg-destructive',
  info: 'bg-info',
  neutral: 'bg-muted-foreground',
};

export default function GradeDot({ grade, className }: { grade: string; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex size-[26px] flex-none items-center justify-center rounded-full font-mono text-[11px] font-bold text-white',
        TONES[gradeTone(grade)],
        className,
      )}
    >
      {grade}
    </span>
  );
}
